
export const URL = (location.hostname == 'isoterminal.com') ? 'https://isoterminal.com/v1' 
    : (location.hostname == 'localhost') ? 'http://localhost:8000'
    : 'http://34.199.68.97:8080' // mca dev url
export const config = {
    headers: {'Access-Control-Allow-Origin': '*'}
};
